@if (title) {
  <h4 class="margin-bottom-0 font-header text-center">{{ title }}</h4>
}
<div class="flex justify-center items-center">
  <div data-cy="quoteSidebarQuoteBlockAmount">
    <p class="quote-amount-big">
      {{ monthlyPremium | currencyUSD: true }}
    </p>
  </div>
  <div>
    <p class="quote-amount-small">.{{ monthlyPremium | decimalDigits }}</p>
    <p class="quote-amount-small">/MO</p>
  </div>
</div>
<div class="row">
  <div class="column twelve text-center quote-amount-small">
    <span data-cy="quoteSidebarQuoteBlockAmountTerm"
      >{{ totalCost | currencyUSD }} / {{ termMonths }} mos</span
    >
  </div>
</div>
